var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.604248 16.192V6.89926C0.604248 6.5506 0.679748 6.22135 0.830748 5.91151C0.981915 5.60151 1.19775 5.34343 1.47825 5.13726L7.67025 0.486264C8.05858 0.188597 8.50092 0.0397644 8.99725 0.0397644C9.49375 0.0397644 9.93792 0.188597 10.3297 0.486264L16.5217 5.13726C16.8022 5.34343 17.0196 5.60151 17.1737 5.91151C17.3279 6.22135 17.405 6.5506 17.405 6.89926V16.192C17.405 16.8073 17.19 17.3284 16.76 17.7553C16.33 18.1823 15.8073 18.3958 15.192 18.3958H12.196C11.8877 18.3958 11.6269 18.2892 11.4137 18.076C11.2007 17.8628 11.0942 17.6021 11.0942 17.2938V12.0075C11.0942 11.6992 10.9877 11.4385 10.7745 11.2255C10.5615 11.0123 10.3008 10.9058 9.9925 10.9058H8.0075C7.69917 10.9058 7.4385 11.0123 7.2255 11.2255C7.01233 11.4385 6.90575 11.6992 6.90575 12.0075V17.2938C6.90575 17.6021 6.79925 17.8628 6.58625 18.076C6.37308 18.2892 6.11233 18.3958 5.804 18.3958H2.808C2.19266 18.3958 1.67158 18.1823 1.24475 17.7553C0.817748 17.3284 0.604248 16.8073 0.604248 16.192Z",
    fill: "#FCAD09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home_active.6606ac317b88da6ab441dcf99015c2a1.svg";
export { ForwardRef as ReactComponent };